import './global.scss';

import Layout from '@/src/components/UI/Layout/Layout';
import { globalStore } from '@/src/store/global/useGlobalStore';
import { StoreProvider } from 'easy-peasy';
import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { useState } from 'react';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { AppGeneral } from '../components/AppComponents/AppGeneral/AppGeneral';
import { ModalUpdatePageMessage } from '../components/AppComponents/ModalUpdatePageMessage/ModalUpdatePageMessage';
import { ModalWelcomeMessage } from '../components/AppComponents/ModalWelcomeMessage/ModalWelcomeMessage';
import LoadingMayz from '../components/Commons/LoadingMayz/LoadingMayz';
import { metadata } from './_document';
import { RouterProvider } from '../store/router/RouterProvider';

export default function MyApp({ Component, pageProps }: AppProps<{ session?: Session }>) {
    const [isLoadingApp, setIsLoadingApp] = useState(true);
    return (
        <>
            {/* //TODO: add <StrictMode> */}
            <Head>
                <title>{metadata.title}</title>
            </Head>
            <SessionProvider session={pageProps.session} refetchInterval={0}>
                <StoreProvider store={globalStore}>
                    <RouterProvider>
                        <AppGeneral loader={<LoadingMayz />} onLoadComplete={() => setIsLoadingApp(false)}>
                            <ReactNotifications />
                            <Layout>
                                <Component {...pageProps} />
                            </Layout>
                            <ModalUpdatePageMessage />
                            <ModalWelcomeMessage />
                        </AppGeneral>
                    </RouterProvider>
                </StoreProvider>
            </SessionProvider>
            {/* </StrictMode> */}
        </>
    );
}
